module.exports = __webpack_public_path__ + "img/DerTurm.5a0ec2e4.svg";